import {
    TFormalOffers,
    TFormalOfferVariationTrees
} from './formalOffers.types';
import { getFormalOfferInterestOnlyPeriod } from './getFormalOfferInterestOnlyPeriod';

/**
 * Builds a map of base formal offer IDs to their IO variation's interest-only period.
 *
 * @param variationTrees The formal offer variation relationship trees.
 * @param formalOffers The list of formal offers.
 * @returns A record mapping base_formal_offer_id to the interest-only period of its IO variation.
 */
export const getInterestOnlyPeriodFromVariationTrees = (
    variationTrees: TFormalOfferVariationTrees,
    formalOffers: TFormalOffers
): Record<number, number> => {
    const periods: Record<number, number> = {};

    for (const tree of variationTrees) {
        const ioVariation = tree.variations?.find(
            (v) => v.variation_type === 'IO'
        );
        if (!ioVariation) continue;

        const ioOffer = formalOffers.find(
            (offer) => offer.formal_offer_id === ioVariation.formal_offer_id
        );
        if (!ioOffer) continue;

        const period = getFormalOfferInterestOnlyPeriod(ioOffer);
        if (period !== null && period !== undefined) {
            periods[tree.base_formal_offer_id!] = period;
        }
    }

    return periods;
};
